export default "__VITE_ASSET__UyD951$N__"